import type { FunctionComponent, MouseEvent } from 'react';

import { Button } from '~/ui/core/button/Button';
import { MicrophoneIcon } from '~/ui/core/icons';

import { Spinner } from '../Spinner';

type TranscribeButtonProps = {
    readonly disabled?: boolean;
    readonly isRecording: boolean;
    readonly isTranscribing: boolean;
    readonly onClick: () => void;
    readonly title?: string;
};

const handleMouseDown = (event: MouseEvent): void => {
    event.preventDefault();
};

export const TranscribeButton: FunctionComponent<TranscribeButtonProps> = ({
    disabled,
    isRecording,
    isTranscribing,
    onClick,
    title,
}) => {
    return (
        <Button
            aria-label={isRecording ? 'Stop recording' : 'Start recording'}
            aria-pressed={isRecording}
            disabled={disabled === true || isTranscribing}
            iconOnly={true}
            isActive={isRecording}
            size="sm"
            title={title}
            type="button"
            variant="tertiary"
            onClick={onClick}
            onMouseDown={handleMouseDown}
        >
            {isTranscribing ? <Spinner style={{ marginRight: 0 }} /> : <MicrophoneIcon />}
        </Button>
    );
};
